/**
 * The client factory. Composes the HTTP core with feature namespaces. Grows one
 * namespace at a time toward the full surface (auth, organizations, collections,
 * workspaces, resources, semanticTags, notifications, vaults, aity, platform).
 */
import { createHttp } from './http.js';
import { resourcesNamespace } from './resources.js';
import { collectionsNamespace } from './collections.js';
import { workspacesNamespace } from './workspaces.js';
import { notificationsNamespace } from './notifications.js';
import { organizationsNamespace } from './organizations.js';
import { semanticTagsNamespace } from './semantic-tags.js';
import { authNamespace } from './auth-endpoints.js';
export function createTydalClient(config) {
    const http = createHttp(config);
    return {
        http,
        auth: authNamespace(http),
        resources: resourcesNamespace(http),
        collections: collectionsNamespace(http),
        workspaces: workspacesNamespace(http),
        notifications: notificationsNamespace(http),
        organizations: organizationsNamespace(http),
        semanticTags: semanticTagsNamespace(http),
    };
}
//# sourceMappingURL=client.js.map